import { AdyenSession, PaymentMethod, SurchargeQuote } from 'types/PaymentMethod';

export enum TokenPaymentStatus {
    Idle = 'idle',
    Processing = 'processing',
    Success = 'success',
    Error = 'error'
}

export interface PaymentMethodsState {
    loading: boolean;
    paymentMethods: Array<PaymentMethod>;
    paymentMethodsFetched: boolean;

    adyenSession: AdyenSession | null;
    sessionLoading: boolean;

    surchargeQuote: SurchargeQuote | null;
    surchargeLoading: boolean;

    tokenPaymentStatus: TokenPaymentStatus;
}
